// extracted by mini-css-extract-plugin
export default {"card":"SearchResult_card__QYeU-","img":"SearchResult_img__oPYdV","svg":"SearchResult_svg__WY1Z5","text":"SearchResult_text__Zdu6A","btn":"SearchResult_btn__-HJWi"};